import React from 'react';
import PropTypes from 'prop-types';
import Button from "UI/Button";
import classNames from 'classnames';

import TextIcon from './TextIcon';
import ImageIcon from './ImageIcon';

export default class ElementToolbar extends React.Component
{
    static propTypes = {
        slide: PropTypes.object.isRequired,

        addTextElement: PropTypes.func.isRequired,
        addImageElement: PropTypes.func.isRequired,
        changeElement: PropTypes.func.isRequired,
    };

    render()
    {
        const {slide, addTextElement, addImageElement, changeElement} = this.props;

        const classes = {
            container: classNames('flex justify-center py-4 my-4'),
            wrapper: classNames('bg-white border rounded-lg'),
            button: classNames('hover:bg-gray-50')
        };

        return <div className={classes.container}  onMouseDown={e => e.stopPropagation()}>
            <div className={classes.wrapper}>
                <Button className={classes.button} type='blank' onClick={() => addTextElement(slide.story_id, slide.id).then(elementId => changeElement(elementId))}>
                    <TextIcon className='w-4 h-4 my-1' />
                </Button>
                <Button className={classes.button} type='blank' onClick={() => addImageElement(slide.story_id, slide.id).then(elementId => changeElement(elementId))}>
                    <ImageIcon className='w-4 h-4 my-1' />
                </Button>
            </div>
        </div>;
    }
}
